/* CARSTN 2026 — Vanilla JS for theme interactions
   Currently: mobile menu drawer toggle, marquee duplication.
   Load via <script src="{{ 'carstn-2026.js' | asset_url }}" defer></script>
*/

(function () {
  // ── Mobile menu drawer ──────────────────────────────────────────────
  const openBtn  = document.querySelector('[data-carstn-menu-open]');
  const closeBtn = document.querySelector('[data-carstn-menu-close]');
  const drawer   = document.querySelector('[data-carstn-drawer]');
  const scrim    = document.querySelector('[data-carstn-scrim]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('menu-drawer--open');
    // keep a11y state in sync: visible = reachable for screen readers + keyboard
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('menu-drawer--open');
    // closed = hidden AND unfocusable (inert), so no focusable-in-aria-hidden traps
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
  }
  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (scrim)    scrim.addEventListener('click', closeDrawer);
  drawer && drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));

  window.addEventListener('resize', () => {
    if (window.innerWidth > 640 && drawer && drawer.classList.contains('menu-drawer--open')) {
      closeDrawer();
    }
  });

  // ── Auto-duplicate marquee items for seamless loop ──────────────────
  // Idempotent — multiple sections referencing carstn-2026.js used to
  // run this several times per track, blowing item count from 12 to 48
  // and making the top marquee scroll way faster than the bottom one.
  document.querySelectorAll('[data-carstn-marquee]').forEach((track) => {
    if (track.dataset.carstnMarqueeInit === '1') return;
    track.dataset.carstnMarqueeInit = '1';
    track.innerHTML += track.innerHTML;
  });

  // ── Obfuscated mailto links ─────────────────────────────────────────
  // HTML stores user + domain in data-attrs, no `mailto:` or `@` in source.
  // We assemble the address on-demand so naïve email harvesters get nothing.
  // The visible label (e.g. "Management & Booking ↗") is left untouched.
  document.querySelectorAll('[data-cuser][data-cdomain]').forEach((a) => {
    const user = a.getAttribute('data-cuser');
    const domain = a.getAttribute('data-cdomain');
    if (!user || !domain) return;
    a.setAttribute('href', 'mailto:' + user + '@' + domain);
    a.removeAttribute('data-cuser');
    a.removeAttribute('data-cdomain');
  });

  // ── Full-screen hero: fill 100svh minus the ACTUAL header + marquee ──
  // The chrome above (announce + header) and the marquee below are responsive,
  // so we measure them and expose --hero-chrome. Hardcoding a px offset would
  // break on other monitor resolutions; this adapts to any size on resize.
  const heroEl = document.querySelector('section.hero');
  if (heroEl) {
    const setHeroChrome = () => {
      const marquee = document.querySelector('.marquee');
      const above = heroEl.getBoundingClientRect().top + window.scrollY; // announce + header
      const below = marquee ? marquee.offsetHeight : 0;
      document.documentElement.style.setProperty('--hero-chrome', Math.round(above + below) + 'px');
    };
    setHeroChrome();
    window.addEventListener('load', setHeroChrome);
    let heroRaf;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(heroRaf);
      heroRaf = requestAnimationFrame(setHeroChrome);
    });
  }
})();
